import {
    createBrowserRouter,
} from 'react-router-dom';
import cookie from 'react-cookies';
import CNF from './Config.js';

/*** 引入路由界面 ***/
import Login from '../pages/logins/Login.js';
import Error404 from './Error404.js';
import App from '../App.js';
import SeurityUpdate from '../pages/securitys/SecurityUpdate.js';
import FindPassword from '../pages/securitys/FindPassword.js';
/*** 引入路由界面 ***/

const BasicRouter = createBrowserRouter([
    {
        path: '/',
        element: <App nav='navItems' m={cookie.load(CNF.cookies.keyUsername) === 'admins' ? 21 : 11} />,
        errorElement: <Error404 />,
    }, {
        path: '/login',
        element: <Login />,
        errorElement: <Error404 />,
    }, {
        path: '/org/infos',
        element: <App nav='navItems' m={11} />,
        errorElement: <Error404 />,
    }, {
        path: '/org/structures',
        element: <App nav='navItems' m={12} />,
        errorElement: <Error404 />,
    }, {
        path: '/org/structureGraph',
        element: <App nav='navItems' m={13} />,
        errorElement: <Error404 />,
    }, {
        path: '/org/apikeys',
        element: <App nav='navItems' m={14} />,
        errorElement: <Error404 />,
    }, {
        path: '/users',
        element: <App nav='navItems' m={21} />,
        errorElement: <Error404 />,
    }, {
        path: '/user/infos',
        element: <App nav='navItems' m={22} />,
        errorElement: <Error404 />,
    }, {
        path: '/groups',
        element: <App nav='navItems' m={3} />,
        errorElement: <Error404 />,
    }, {
        path: '/roles',
        element: <App nav='navItems' m={4} />,
        errorElement: <Error404 />,
    }, {
        path: '/authoritys',
        element: <App nav='navItems' m={5} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/user/utacd',
        element: <App nav='navItems' m={61} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/user/udatc',
        element: <App nav='navItems' m={62} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/user/udebc',
        element: <App nav='navItems' m={63} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/user/udsxc',
        element: <App nav='navItems' m={64} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/user/utecy',
        element: <App nav='navItems' m={65} />,
        errorElement: <Error404 />,
    }, {
        path: '/reports/user/udbcy',
        element: <App nav='navItems' m={66} />,
        errorElement: <Error404 />,
    }, {
        path: '/log/operations',
        element: <App nav='navItems' m={71} />,
        errorElement: <Error404 />,
    }, {
        path: '/log/logins',
        element: <App nav='navItems' m={72} />,
        errorElement: <Error404 />,
    }, {
        path: '/users/security',
        element: <App nav='navUserItems' m={1} />,
        errorElement: <Error404 />,
    }, {
        path: '/user/security/update/:name',
        errorElement: <Error404 />,
        loader: async ({ params }) => {
            return params
        },
        element: <SeurityUpdate />
    }, {
        path: '/users/basicinfo',
        element: <App nav='navUserItems' m={2} />,
        errorElement: <Error404 />,
    }, {
        path: '/users/security/findPassword/:name',
        errorElement: <Error404 />,
        loader: async ({ params }) => {
            return params
        },
        element: <FindPassword />
    },
]);

export default BasicRouter